import api from './client';

export const getConversations = (params) => api.get('/conversations', { params });
export const getConversation = (id) => api.get(`/conversations/${id}`);
export const getMessages = (conversationId, params) => api.get(`/conversations/${conversationId}/messages`, { params });
export const sendMessage = (conversationId, data) => api.post(`/conversations/${conversationId}/messages`, data);
export const markRead = (id) => api.patch(`/conversations/${id}/read`);
export const closeConversation = (id) => api.patch(`/conversations/${id}/close`);
export const reopenConversation = (id) => api.patch(`/conversations/${id}/reopen`);
export const assignConversation = (id, data) => api.patch(`/conversations/${id}/assign`, data);
export const deleteConversation = (id) => api.delete(`/conversations/${id}`);
